import React from "react"
import ContentLoader from "react-content-loader"
import './styles.scss';

const BannerHeroSkeleton = ({contentNoImageProps}) => {
  const width = 8400
  const height = 4000 
  const backgroundColorOne = contentNoImageProps?.backgroundColorOne || '#1C1C1C'
  const backgroundColorTwo = contentNoImageProps?.backgroundColorTwo || '#343434'
  return (
      <div className='BannerHeroSkeletonContainer' >
        <ContentLoader 
        className='BannerHeroSkeleton' 
        speed={2}
        width="100%" 
        height="100%"
        backgroundColor={backgroundColorOne}
        foregroundColor={backgroundColorTwo}
        >
          <rect width={width} height={height} />
        </ContentLoader>
      </div>
  )
}

export default BannerHeroSkeleton;